import HttpReq from "../../service/httpReq"
import Cache from "./cache"


function cacheKey(schemaId, includeProvenance) {
    return "ReprtsRepo" + schemaId + ":" + includeProvenance
}

//TODO Rename to ReprtsRepo
class GlobalReportsRepo {
    static publicPath = 'api/reports'

    /**
     * @param {number} schemaId Required
     * @param {Function} reportConsumer Required
     * @param {Function} [errorConsumer] Optional
     * @param {boolean} [includeProvenance] Optional See ReportsRepo.listBySchema.
     */
    static listBySchema(schemaId, reportConsumer, errorConsumer, includeProvenance = false) {
        const params = new URLSearchParams({
            schemaId: String(schemaId),
            includeProvenance: String(includeProvenance)
        })
        Cache.get(cacheKey(schemaId, includeProvenance), func => {
            HttpReq.get(GlobalReportsRepo.publicPath + "?" + params, func, errorConsumer)
        }, reportConsumer)
    }

}

export default GlobalReportsRepo